import React, { ReactNode, useEffect, useMemo } from 'react'
import './styles.css'
import { Error404 } from '../Error404/Error404'
import { Home } from '../pages/home/Home'
import { useLocalState } from '../../shared/UseLocalState'
import { appState } from '../../state/App.state'
import { Registration } from '../pages/registration/Registration'
import { Riders } from '../pages/riders/Riders'
import { Horses } from '../pages/horses/Horses'
import { AddressChange } from '../pages/address-change/AddressChange'

const routes = new Map<string, ReactNode>([
  ['', <Home />],
  ['#', <Home />],
  ['#/home', <Home />],
  ['#/registration', <Registration />],
  ['#/horses', <Horses />],
  ['#/riders', <Riders />],
  ['#/address-change', <AddressChange />]
])

export const AppContent = () => {
  /* GLOBAL STATE */
  const hash = useLocalState(appState.hash$, appState.hash$.value)

  /* STATE */
  const route = useMemo(() => routes.get(hash?.toLowerCase()) ?? <Error404 />, [hash])

  /* TEMPLATE */
  return <div className='app-content-container'>{route}</div>
}
